module.exports = __webpack_public_path__ + "entry-41b28522/robin-maurer-photo-369d3f961b87f9d8b18a4655b6c9a9d4.webp";